// resources/js/plugins/translations.js
export default {
  install(Vue) {
    Vue.prototype.__ = function(key, replacements = {}) {
      const translations = this.$page.props.translations || {};
      
      // Split key into parts (e.g., "agenda_event.personal_office.greetings.standard")
      const parts = key.split('.');
      if (parts.length < 1) return key;
      
      // Safely navigate through translation object
      const result = parts.reduce((obj, part) => {
        return (obj && obj[part] !== undefined) ? obj[part] : null;
      }, translations);
      
      // Handle missing translations
      if (result === null || typeof result === 'object') {
        if (process.env.NODE_ENV === 'development') {
          console.warn(`Missing translation: ${key}`);
        }
        return key;
      }
      
      // Replace placeholders (including HTML)
      return Object.entries(replacements).reduce((str, [k, v]) => {
        return str.replace(new RegExp(`:${k}`, 'g'), v);
      }, result);
    };
  }
};